const ignoreErrors = {
    intl: () => {
        const consoleError = console.error.bind(console);
        /* eslint-disable @typescript-eslint/no-explicit-any */
        return (console.error = (message, ...args) => {
            if (typeof message === 'string' &&
                message.startsWith('[React Intl]') &&
                import.meta.env.MODE === 'development') {
                return;
            }
            if (message instanceof Error &&
                message.message.startsWith('[@formatjs/intl') &&
                import.meta.env.MODE === 'development') {
                return;
            }
            consoleError(message, ...args);
        });
    },
};
export default ignoreErrors;
//# sourceMappingURL=ignoreErrors.js.map